import * as React from 'react';

import {IconAvatar} from '../../avatar/icon-avatar';
import {colors} from '../../colors/colors';
import {Stack} from '../../layout/stack/stack';
import {Body} from '../../typography/body';

type Props = {
    title: string;
    description: string;
    icon: React.ComponentType<any>;
};

export function FeatureHighlight(props: Props) {
    return (
        <Stack spacing={16}>
            <IconAvatar
                icon={props.icon}
                avatarSize={40}
                iconSize={24}
                iconColor={colors.aiPurplePrimary}
                backgroundColor={colors.aiPurplePinkLt}
                shape='square'
            />
            <Stack spacing={8}>
                <Body size='large' isBold={true} useDoyle={true}>
                    {props.title}
                </Body>
                <Body maintainLineBreaks={true}>{props.description}</Body>
            </Stack>
        </Stack>
    );
}
